import { memo } from "react";
import { Navigate, generatePath } from "react-router";

import { PATHS } from "@/routes/paths";

import { DiscountOrdinaryEditPagePresenter } from "./presenter";
import * as QueryRepository from "../model/repository/query";

type Props = {
	hotelID: string;
	discountID: string;
};

export const DiscountOrdinaryEditPageContainer = memo(({ hotelID, discountID }: Props) => {
	const { discountOrdinaryForOrdinaryServerModel } = QueryRepository.useDiscountOrdinaryForOrdinaryQuery(
		hotelID,
		discountID,
	);

	if (!discountOrdinaryForOrdinaryServerModel) {
		return <Navigate to={generatePath(PATHS.HOTEL.ITEMS.DISCOUNT.TOP, { hotelID })} />;
	}

	return (
		<DiscountOrdinaryEditPagePresenter
			hotelID={hotelID}
			discountOrdinaryForOrdinaryServerModel={discountOrdinaryForOrdinaryServerModel}
		/>
	);
});

DiscountOrdinaryEditPageContainer.displayName = "DiscountOrdinaryEditPageContainer";
